import { render } from "./InventarioDetallePage.vue?vue&type=template&id=20d02dbd&scoped=true"
import script from "./InventarioDetallePage.vue?vue&type=script&lang=js"
export * from "./InventarioDetallePage.vue?vue&type=script&lang=js"

import "./InventarioDetallePage.vue?vue&type=style&index=0&id=20d02dbd&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d02dbd"]])

export default __exports__